package com.daytimegaming.ourdailyfinances.domain.model

data class RecurringAmount(
    val amount: Double,
    val isoCurrencyCode: String?
)

data class RecurringTransactionStream(
    val streamId: String,
    val accountId: String,
    val streamType: String,
    val description: String,
    val merchantName: String?,
    val firstDate: String,
    val lastDate: String,
    val predictedNextDate: String?,
    val frequency: String,
    val transactionIds: List<String>,
    val averageAmount: RecurringAmount,
    val lastAmount: RecurringAmount,
    val isActive: Boolean,
    val status: String,
    val personalFinanceCategory: PersonalFinanceCategory?
)
